import { API } from '@Providers';

export default async function getFosterContractsService() {
  const endpoint = '/api/shelter/foster-settings/get-foster-contracts';
  return API({ endpoint });
}
